<template>
    <program-resources />
</template>

<script>
import ProgramResources from '@/views/Employee/ProgramComponents/ProgramDetails/ProgramResources.vue'

export default {
    name: "TeachResources",
    components: { ProgramResources },
}
</script>